import React from 'react';
import { Phone } from 'lucide-react';
import { business } from '../data/business';
const stats = [{
  value: '40+',
  label: 'Lincoln homes cleaned'
}, {
  value: '3',
  label: 'Exterior services'
}, {
  value: '1',
  label: 'Owner on every job'
}];
export function AboutMason() {
  return <section id="about" className="w-full bg-white py-16 lg:py-24" data-id="element-1" data-mp="2smvy2rywoo5t">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-2" data-mp="2sp8ayqpt48c0">
        <div className="overflow-hidden rounded-[2rem] bg-brand-sky" data-id="element-3" data-mp="1v0f1joxzyel4">
          <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr]" data-id="element-4" data-mp="1zy85ebbtuwi8">
            <div className="relative p-6 lg:p-8" data-id="element-5" data-mp="200kowsx8hexe">
              <img src={business.masonPhoto} alt={`${business.owner}, owner and operator of ${business.name}`} className="h-80 w-full rounded-3xl object-cover object-top shadow-lg lg:h-full" data-id="element-6" data-mp="24xbatwvpz4qq" />
            </div>

            <div className="p-6 pb-10 lg:py-12 lg:pr-12" data-id="element-7" data-mp="3ke1qem8dxhkj">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-teal" data-id="element-8" data-mp="3kciawxujzajt">
                About the owner
              </p>
              <h2 className="mt-3 font-display text-3xl leading-[0.95] tracking-tight text-brand-navy sm:text-5xl" data-id="element-9" data-mp="c4ttcwpoi3i4">
                HI, I&apos;M MASON.
              </h2>
              <div className="mt-5 space-y-4 text-lg leading-relaxed text-brand-navy/75" data-id="element-10" data-mp="77k5hlhxtzwe">
                <p data-id="element-11" data-mp="33m391xbg8z4">
                  I started Bucket Hat Cleaning right here in {business.city}{' '}
                  with a squeegee, a ladder and a bucket hat. I still show up to
                  every job myself — my name is the only reputation I have in
                  this town.
                </p>
                <p data-id="element-12" data-mp="3ki12pd1171hh">
                  This year I added pressure washing, so the same neighbor who
                  cleans your glass and gutters can bring your driveway, patio
                  and siding back to life too.
                </p>
              </div>

              <dl className="mt-8 grid grid-cols-3 gap-4 border-y border-brand-navy/10 py-6" data-id="element-13" data-mp="36lxatqdmr586">
                {stats.map(stat => <div key={stat.label} data-id="element-14" data-mp="2wzcxnv6ywgzx">
                    <dt className="sr-only" data-id="element-15" data-mp="30yu2cmekla41">{stat.label}</dt>
                    <dd data-id="element-16" data-mp="30w90vyi6ow6t">
                      <span className="block font-display text-3xl tracking-tight text-brand-blue" data-id="element-17" data-mp="2mzc83rii94na">
                        {stat.value}
                      </span>
                      <span className="mt-1 block text-xs font-semibold text-brand-navy/60" data-id="element-18" data-mp="2rzqk1kn88yql">
                        {stat.label}
                      </span>
                    </dd>
                  </div>)}
              </dl>

              <div className="mt-8 flex flex-col gap-5 sm:flex-row sm:items-center" data-id="element-19" data-mp="35ygestmkqmbs">
                <a href={business.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-navy px-7 py-4 text-base font-bold text-white transition-colors hover:bg-brand-navy/90" data-id="element-20" data-mp="3aw86pnn7y8fz">
                  <Phone className="h-5 w-5" aria-hidden="true" data-id="element-21" data-mp="79hmvpsyomjc" />
                  Talk to Mason: {business.phone}
                </a>
                <p className="font-display text-sm tracking-tight text-brand-navy/70" data-id="element-22" data-mp="1mzikeekdjyok">
                  &ldquo;FRESH HATS. CLEAN LOOK. EVERY TIME.&rdquo;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}